export default __webpack_public_path__ + "static/1.1-0d94b9af098755bcbe5aa29a9e563163.webp";